import axios from 'axios'
import qs from 'qs'
import {isObject} from './types'

const axiosInstance = axios.create()

export const ajax = (url, params, config) => {
  if (!config) config = {}
  config.url = url
  if (params) {
    let {query, data, form, method, get, post} = params
    if (!query) query = get
    if (!data) data = post
    if (query) config.params = query
    if (data) config.data = data
    else if (form) config.data = qs.stringify(form)
    if (!method) method = (data || form) ? 'post' : 'get'
    config.method = method
  }
  return axiosInstance(config)
}

/**
 * default response
 * {
 *   success:true, message:"OK", result:[], total, page, size
 * }
 */
const parseStatements = (parse, params, res) => { //data/res参数必须有，将会被statement中代码使用
  let output = {}
  if (parse) Object.entries(parse).forEach(([key, statement]) => output[key] = eval(statement))
  return output
}

export const request = function (service, params, insPagination) {
  let {
    // 请求
    url, query, data, form, method, config,
    // 解析
    pagination, parse
  } = service

  //请求参数
  if (query) query = parseStatements(query, params)
  if (data) data = parseStatements(data, params)
  if (form) form = parseStatements(form, params)

  let defResponseParse = {success: 'res.success', message: 'res.message', result: 'res.result'}

  //翻页参数
  if (pagination) { //service中有pagination则认为此请求为列表翻页请求
    Object.assign(defResponseParse, {total: 'res.total', page: 'res.page', size: 'res.size'})
    if (!isObject(pagination)) pagination = {}
    pagination = Object.assign({page: 'page', size: 'size'}, pagination)
    query = Object.assign({[pagination.page]: insPagination.page, [pagination.size]: insPagination.size}, query)
  }

  //返回内容解析
  parse = Object.assign(defResponseParse, parse)

  return ajax(url, {query, data, form, method}, config).then(res => {
    let response = parseStatements(parse, params, res.data)
    if (pagination) {
      let {page, size, total} = response
      if (!isNaN(total)) insPagination.total = total
      if (!isNaN(size)) insPagination.size = size
      if (!isNaN(page)) insPagination.page = page
    }
    return response
  })
}